// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__7xQW2","title":"Info_title__3O0Gr","links":"Info_links__17v9B","link":"Info_link__XK4nW","logo":"Info_logo__2eEhN"};